import React, { useState, useRef, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Tabs from '../../../../Components/Tabs';
import DocumentListScreen from './DocumentListScreen';
import InwardOutwardListScreen from './InwardOutwardListScreen';
import DocumentRackController from '../../../Controllers/AdminScreens/DocumentRack/DocumentRackController';


const DocumentRackScreen = ({ refreshDashboard, setRefreshDashboard }) => {
    const {
        fetchKYCDocumentsRefresh,
        kycDocumentList,
        kycListError,
        kycListLoading,
        setKYCListError,
        setKycListLoading,
        setKycDocumentList,
        hasMoreServerData,offset,isFilterData,setIsFilterData

    } = DocumentRackController(refreshDashboard, setRefreshDashboard)

    const { state } = useLocation();
    const [selectedTab, setSelectedTab] = useState(state?.selectedTab || 0);
    const [disabledTabs, setDisabledTabs] = useState([]);

    useEffect(() => {
        const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_') || '{}');
        const { per_name_sub_json } = storedUserInfo?.user_permissions?.doc_rack || {};

        const docTabDisabled = per_name_sub_json?.doc_search === 0;
        const disabledTabIndices = docTabDisabled ? [1] : [];
        setDisabledTabs(disabledTabIndices);
        if (disabledTabIndices.includes(selectedTab)) {
            setSelectedTab(0);
        }
    },[selectedTab])

    const handleTabChange = (index) => {
        if (disabledTabs.includes(index)) return;
        setSelectedTab(index);
    };



    return (
        <div style={styles.mainContent}>
            <div className='title-container' style={{ paddingBottom: 10 }}>
                <h2 className='title'>Document Rack</h2>
            </div>

            <div >
            {/* <Tabs tabs={['Inward/Outward', 'Document']} */}
                <Tabs tabs={['Inward/Outward']}
                selectedIndex={selectedTab}
                onTabChange={handleTabChange}
                disabledTabs={disabledTabs}>
                    <InwardOutwardListScreen kycListLoading={kycListLoading}
                kycListError={kycListError}
                kycDocumentList={kycDocumentList}
                onRefresh={fetchKYCDocumentsRefresh}
                setKycDocumentList={setKycDocumentList}
                setKYCListError={setKYCListError}
                setKycListLoading={setKycListLoading}
                hasMoreServerData={hasMoreServerData}
                offset={offset}
                isFilterData={isFilterData}
                setIsFilterData={setIsFilterData}
                />
                    <DocumentListScreen />
                </Tabs>
            </div>

        </div>


    )

};

const styles = {
    mainContent: {
        width: '95%',
        margin: 'auto'
    }

}

export default DocumentRackScreen;